import { ChallengeCardImage } from './ChallengeCard.styles';
import { imageVariantProps } from './ChallengeCard.types';
import ShapeImg from 'Icons/ShapeImg';

export const getImageShapeByVariant = ({
  variant,
  imageSrc,
}: imageVariantProps) => {
  switch (variant) {
    case 'shape1':
      return <ChallengeCardImage src={imageSrc} alt="image" />;
    case 'shape2':
      return <ShapeImg imageUrl={imageSrc} />;
    default:
      return <ChallengeCardImage src={imageSrc} />;
  }
};

export const getRandomImageShape = (): string => {
  const shapes = ['shape1', 'shape2'];
  const randomIndex = Math.floor(Math.random() * shapes.length);
  return shapes[randomIndex];
};
